module.exports = __webpack_public_path__ + "../resources/img/ic_complete_number_4_lt.6f1953c1.svg";